export const capitalizeWords = (str) => {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const handleInputBlur = (event) => {
  event.target.value = capitalizeWords(event.target.value);
};
